import { createContext } from 'react';

const PhoneSettingsContext = createContext();
PhoneSettingsContext.displayName = 'PhoneSettingsContext';

export default PhoneSettingsContext;
